import fetch from 'utils/fetch';

export function topUpLogList( startTime,endTime,accountBegin,accountEnd,agent,productId,type,status,psize,currentPage) {
    const data = {
        startTime,
        endTime,
        accountBegin,
        accountEnd,
        productId,
        agent,
        type,
        status,
        psize,
        currentPage
    };
    return fetch({
        url: '/topUpLog',
        method: 'get',
        params : data
    });
}



// WEBPACK FOOTER //
// ./src/api/topUpLog.js